import Clarity from '@microsoft/clarity'
import { AppConfigService } from '../config'

export class ClarityService {
  private static initialized = false

  static initOnce(): void {
    if (this.initialized) return

    const projectId = this.readProjectId()
    if (!projectId) {
      console.log('🔕 Clarity disabled: VITE_CLARITY_PROJECT_ID is not set')
      return
    }

    try {
      Clarity.init(projectId)
      this.initialized = true
      console.log('✅ Clarity initialized')
    } catch (error) {
      console.warn('⚠️ Failed to initialize Clarity:', error)
    }
  }

  private static readProjectId(): string {
    return String(AppConfigService.getString('VITE_CLARITY_PROJECT_ID') ?? '').trim()
  }
}
